<template>
  <div class="header__locale">
    <ul>
      <li
          v-for="locale in supportedLocales"
          :key="locale"
          @click="switchLocale(locale)"
          :class="{ 'active' : locale == $i18n.locale }"
      >
        {{ $t('menu.' + locale)  }}
      </li>
    </ul>
  </div>
</template>

<script>
import { Trans } from '@/plugins/Translation'

export default {
  name: 'LocaleSwitcher',
  computed: {
    supportedLocales () {
      return Trans.supportedLocales
    },
  },
  methods: {
    switchLocale (locale) {
      if (this.$i18n.locale !== locale) {
        const to = this.$router.resolve({ params: { locale } })
        return Trans.changeLocale(locale).then(() => {
          this.$router.push(to.location)
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
ul {
  margin: 0 30px;
  display: flex;

  li {
    cursor: pointer;
    margin: 0 10px;
    list-style: none;
    color: #615d5d;
    &.active {
      cursor: default;
      color: #ffffff;
    }
  }
}
</style>
